import { useRouter } from 'next/router';

import { type ListingSuggestion } from './listingSearch';
import { portalListingPath } from './portalPages';
import { isTexasSuggestion } from './texasRollout';

/**
 * Shared handoff from an inventory search to a listing page. Texas properties
 * stay in the client-routed Cosmos flow; every other property hard-navigates so
 * the Worker chooses Cosmos or Rails using the current global entry flag.
 */
export const useListingNavigation = () => {
  const router = useRouter();
  return (listing: ListingSuggestion) => {
    const path = portalListingPath(listing.slug);
    if (isTexasSuggestion(listing)) {
      void router.push(path);
      return;
    }
    // A full navigation leaves the app, so the MLS/ad attribution params
    // survive only if they stay on the URL.
    window.location.assign(path + window.location.search);
  };
};
